/**
 * PageTransition — Wrapper d'animation appliqué à chaque changement de route.
 *
 * Approche : re-render du contenu avec une clé égale au pathname → l'animation
 * CSS `cb-page-in` se rejoue à chaque navigation. Aucune dépendance externe
 * (framer-motion inutile), rapide, respecte prefers-reduced-motion.
 *
 * Placé DANS <BrowserRouter> et AUTOUR de <Routes> (voir App.js).
 */
import { useLocation } from "react-router-dom";

export default function PageTransition({ children }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="cb-page-in" data-testid="page-transition">
      {children}
    </div>
  );
}
